import PropTypes from "prop-types";

export default function Checkbox({
    checked,
    onChange,
    id,
    children,
    color,
    ...props
}) {
    return (
        <div
            className="checkbox-component"
            style={color ? { "--checkbox-color": color } : undefined}
        >
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                {...props}
            />
            <label htmlFor={id} style={color ? { color: color } : undefined}>
                {children}
            </label>
        </div>
    );
}

Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    color: PropTypes.string,
};
